window.StatementsManager = Backbone.Model.extend({

    initialize: function(params) {
        this.container = params.container;
		this.agent = params.agent;
		
		// Logger.info("StatementsManager.init", this)

		this.loadXML(params.path);
		
		this.listenTo(this.container.componentList.LRSConnector, "onAgentUpdated", (e) => {
			Logger.info("StatementsManager.onAgentUpdated", e)
		})
    },

    loadXML: function(path) {
        var loader = new AssetLoader({name: "StatementsManager"});

		loader.addXML(path, null, null, this, "handleXMLLoaded");
		loader.start();
    },

    handleXMLLoaded: function(e) {
        if(!e.loader.loaded) {
            Logger.error("StatementsManager: failed to load XML");
            return;
        }

		this.data = this.getData($(e.resource.getXML()));
		this.setupHandlers();
    },

    getData: function($xml) {
        var data = {};
        data.items = [];

        $xml.find("item").each(function(index, item) {
            var $item = $(item);
			data.items.push({
                name: $item.find("key").text(),
                path: $item.find("value").text()
            });
		});

        return data;
    },

    setupHandlers: function() {
        _.each(this.data.items, function(item) {
            var handler = StatementsManager.HANDLERS[item.name];

            if(typeof handler === "function") {
                var instance = new handler({
                    container: this.container,
                    name: item.name,
                    path: item.path,
                    agent: this.agent
                });
                this.listenTo(instance, "onReady", this.handleStatementReady);
            } else {
                Logger.warn("StatementsManager: couldn't load handler " + item.name);
            }
        }, this);
    },

    handleStatementReady: function(e) {
        this.trigger("onStatementsReady", e.statements);
    }
}, {
	HANDLERS: {},
    CMI_LIST_SEPARATOR: "[,]"
});
